import { LocationIcon } from "../../constants/svg";
import classes from "./ViewJobDetails.module.css";
import Twitter from "../../assets/images/JobsDetails/twitter-2.svg";
import Instagram from "../../assets/images/JobsDetails/instagram-2.svg";
import Facebook from "../../assets/images/JobsDetails/facebook-2.svg";
import Website from "../../assets/images/JobsDetails/website-2.svg";
import Share from "../../assets/images/JobsDetails/share-2.svg";
import Linkedin from "../../assets/images/JobsDetails/linkedin-2.svg";
import { useLocation, useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { errorHandler } from "../../utils";
import {
  getAllJobsForTalent,
  getClientJobById,
} from "../../services/clientCalls";
import { talentProfile } from "../../services/talentCalls";
import moment from "moment";
import Loop from "../../assets/loader/loop.svg";
import { Link } from "react-router-dom";
import FullScreenLoader from "../Loaders/FullScreen/loader";
import { currencyFormat } from "../../utils/functions";
import CompanyAvatar from "../../assets/svgs/companyAvatar.svg";

const JobDetails = () => {
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  // const { state } = useLocation();
  const [state, setData] = useState(null);
  const [applicants, setApplicants] = useState([]);

  const fetchSingleJob = async () => {
    try {
      setLoading(true);
      const res = await getClientJobById(id);
      if (res?.data.data.job) {
        setData(res?.data?.data?.job);
        setApplicants(res?.data?.data?.formattedApplicants || []);
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error"
          );
    } finally {
      setLoading(false);
    }
  };

  const hasClientSelected = applicants?.some(
    (a) => a?.status?.toLowerCase() === "selected by client"
  );

  useEffect(() => {
    fetchSingleJob();
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className={classes.parent}>
        <div
          className={`flex ${classes.between} ${classes.info} ${classes.column}`}
        >
          <div className={`flex ${classes.info} ${classes.column}`}>
            <div className={`center-flex ${classes.picture}`}>
              <img src={CompanyAvatar} alt="" className={classes.companyImg} />
            </div>
            <div>
              <h3>{state?.title || state?.job?.title}</h3>
              {/* <p className="mt-sm mb-sm">{state?.description || state?.job?.description}</p> */}
              <p className={`flex ${classes.info}`}>
                <LocationIcon /> {state?.location || state?.job?.location}
              </p>
            </div>
          </div>
          <div className="mt-sm">
            <h3 className={classes.right}>
              &#8358;
              {currencyFormat(
                Number((state?.budget || state?.job?.budget) ?? 0)
              )}{" "}
              monthly
            </h3>
            <p className={classes.subtxt}>
              ({state?.duration}) {moment(state?.startDate).format("MMM yyyy")}{" "}
              - {moment(state?.endDate).format("MMM YYYY")}
            </p>
            <div className={`flex mt-sm ${classes.links} ${classes.info}`}>
              <img src={Share} alt="Share" />
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Website} alt="Web" />
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Linkedin} alt="Linkedin" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Instagram} alt="Instagram" />
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Facebook} alt="Facebook" />
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Twitter} alt="Twitter" />
              </a>
            </div>
          </div>
        </div>
        <div className={`mt-md mb-md ${classes.hrRule}`} />
        <div className={classes.gap}>
          <div>
            <div>
              <h4 className="capitalise">Job Information</h4>
              <div className={classes.jobInfoRow}>
                <div className={classes.jobInfoCol}>
                  <p>
                    Job type: <span> {state?.type || state?.job?.type}</span>
                  </p>
                  <p>
                    Work mode:{" "}
                    <span> {state?.workMode || state?.job?.workMode}</span>
                  </p>
                  <p>
                    Date posted:{" "}
                    <span>
                      {" "}
                      {moment(state?.createdAt || state?.job?.createdAt).format(
                        "DD MMM yyyy"
                      )}
                    </span>
                  </p>
                </div>
                {/* <div className={classes.jobInfoCol}>
                  <p>
                    Skills & Requirements{" "}
                    <p>
                      {state?.skillsAndRequirements?.map((item, idx) => (
                        <span key={idx}> {item} </span>
                      ))}
                    </p>
                  </p>
                </div> */}
              </div>
            </div>
          </div>

          <div
            className={`flex ${classes.between} ${classes.divider} ${classes.column}`}
          >
            <div className={`flow ${classes.objective}`}>
              <h4> Description </h4>
              <p>{state?.description}</p>
            </div>
          </div>

          <div
            className={`flex ${classes.between} ${classes.divider} ${classes.column}`}
          >
            <div className={`flow ${classes.objective}`}>
              <h4>Acceptance Criteria</h4>
              <p>{state?.acceptanceCriteria}</p>
            </div>
          </div>

          <div
            className={`flex ${classes.between} ${classes.divider} ${classes.column}`}
          >
            <div className={`flow ${classes.objective}`}>
              <h4>Objectives</h4>
              <p>{state?.objectives}</p>
            </div>
          </div>

          <div
            className={`flex ${classes.between} ${classes.divider} ${classes.column}`}
          >
            <div className={`${classes.candidateRow}`}>
              <div className={`flex ${classes.candidateCol}`}>
                <h4>Candidates</h4> <h4>Status</h4>
              </div>

              {applicants?.map((item, idx) => {
                const status = item?.status?.toLowerCase();
                const talentName = item?.talent?.firstName;
                const applicantId = item?.applicantId;
                const knownHire = status === "selected by client" || status === "left";

                return (
                  <div className={classes.candidateColStatus} key={idx}>
                    {hasClientSelected ? (
                      knownHire ? (
                        <Link
                          to={`/talent-profile/review/${applicantId}`}
                          state={{ talent: item?.talent, job: { _id: id } }}
                        >
                          {talentName}
                        </Link>
                      ) : (
                        <p>John Doe</p>
                      )
                    ) : (
                      <Link
                        to={`/talent-profile/review/${applicantId}`}
                        state={{ talent: item?.talent, job: { _id: id } }}
                      >
                        {knownHire ? talentName : "John Doe"}
                      </Link>
                    )}

                    {/* STATUS BADGES */}
                    {status === "recommended" && (
                      <p className={classes.statusBtnRec}>Recommended</p>
                    )}

                    {status === "applied" && (
                      <p className={classes.statusBtnApp}>Applied</p>
                    )}

                    {status === "selected by client" && (
                      <p className={classes.statusBtnSbc}>Selected by client</p>
                    )}

                    {status === "cancelled" && (
                      <p className={classes.statusBtnCls}>Cancelled</p>
                    )}

                    {status === "left" && (
                      <p className={classes.statusBtnCls}>Hire left</p>
                    )}

                    {status === "pending_removal" && (
                      <p className={classes.statusBtnCls}>Cancelled</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className={`flex ${classes.between} ${classes.column}`}>
            <div className={`flex  ${classes.jobStatus}`}>
              <h4>Job Status</h4>{" "}
              <span className={classes.statusBtn}>{state?.jobStatus}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobDetails;
